export default {
    title: 'Dashboard RIPS',
    error: {
        title: 'Unable to load the dashboard',
        detail: 'Detail',
        action: 'Please try again.'
    }
}